export class StageDisplayState {
    public static FULL_SCREEN: string = "fullScreen";
    public static FULL_SCREEN_INTERACTIVE: string = "fullScreenInteractive";
    public static NORMAL: string = "normal";
}
